export class LoadFormData {
  static byIdInputs (campos) {
    // Object.keys(campos).forEach(function (key) {
    //   let element = document.getElementById(key)
    //   if (!element) { continue; }
    //   element.value = campos[key]
    //   console.log(campos, key)
    // })

    for (let key in campos) {
      let element = document.getElementById(key)

      if (element) {
        setTimeout(function () {
          element.value = campos[key]
        }, 500)
      }
    }
  }
}
